// extracted by mini-css-extract-plugin
export default {"button":"add-cart-item-module--button--3x3zE","content":"add-cart-item-module--content--3uFVg","icon":"add-cart-item-module--icon--3uQjI"};